module.exports = __webpack_public_path__ + "static/media/event-ggj2019.e0f82419.png";